import React, { useState, useContext } from 'react';
// import uploadFile from './helpers/helpers';
import { parse, stringify } from 'svgson';

import Jimp from 'jimp';
import Potrace from 'potrace';

import { Button } from 'antd';

import { AppContext } from '../../../index';

import { closestColor, rgbToHex } from '../../../../../helpers/helpers.js';
import '../index.css';


const Submit = (props) => {
    const {svgString, setSvgString} = useContext(AppContext);

    const onClick = (event) => {

        props.setIsLoading(true);
        props.setIsModalVisible(true)
        console.log("the colors are: ", props.colors.length)
        const numLayers = props.colors.length;
        const COLORS = new Array(numLayers);

        // convert hex colors to RGB
        for (let index = 0; index < numLayers; index++) {
            if (props.colors[index][0].value != "") {
                const rgba = Jimp.intToRGBA(parseInt("0x" + props.colors[index][0] + "00"))
                COLORS[index] = [rgba['r'], rgba['g'], rgba['b']];
            }

        }

        Jimp.read(URL.createObjectURL(props.file))
            .then(image => {
                // Get Image width and height
                image.crop(props.crop.x, props.crop.y, props.crop.width, props.crop.height)
                const height = image.getHeight();
                const width = image.getWidth();

                // make each color its own layer and set it to white
                const colorLayers = new Array(numLayers)

                for (let i = 0; i < numLayers; i++) {
                    colorLayers[i] = new Jimp(width, height, 0xFFFFFFFF);
                }

                //loop through all colors and set the pixel color according to the closest color
                for (let x = 0; x < width; x++) {
                    for (let y = 0; y < height; y++) {
                        const rgba = Jimp.intToRGBA(image.getPixelColor(x, y));
                        // checks for transparent pixels
                        if (rgba['a'] < 25) {
                            continue;
                        }
                        const pixelColorRGB = Jimp.intToRGBA(closestColor(image.getPixelColor(x, y), COLORS, numLayers));
                        for (let color_i = 0; color_i < colorLayers.length; color_i++) {
                            if (pixelColorRGB['r'] == COLORS[color_i][0] && pixelColorRGB['g'] == COLORS[color_i][1] && pixelColorRGB['b'] == COLORS[color_i][2])
                                colorLayers[color_i].setPixelColor(0x000000FF, x, y)
                        }
                    }
                }

                // props.setColorLayers(colorLayers);
                // props.setStep(1);
                // props.setIsLoading(false);

                const traces = Array(numLayers);

                for (let i = 0; i < numLayers; i++) {
                    traces[i] = new Potrace.Potrace();
                }

                const tsize = props.despeckle;
                const oTolerance = props.simplifyCurves;
                const amax = props.smoothness;

                // You can also pass configuration object to the constructor
                for (let traces_i = 0; traces_i < traces.length; traces_i++) {
                    traces[traces_i].setParameters({
                        color: rgbToHex(COLORS[traces_i][0], COLORS[traces_i][1], COLORS[traces_i][2]),
                        turdSize: tsize,
                        optTolerance: oTolerance,
                        alphaMax: amax
                    });
                }


                const promises = Array(numLayers);

                for (let i = 0; i < numLayers; i++) {
                    promises[i] = new Promise((resolve, reject) => {
                        colorLayers[i].getBase64(Jimp.MIME_JPEG, function (err, src) {
                            traces[i].loadImage(src, function (err) {
                                resolve();
                            });
                        });

                    })
                }

                Promise.all(promises).then(() => {
                    const svgHead = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"" + width + "\" height=\"" + height + "\" viewBox=\"0 0 " + width + " " + height + "\" version=\"1.1\">"
                    const svgTail = "</svg>"
                    var newSVG = svgHead
                    for (let index = 0; index < traces.length; index++) {
                        if (props.colors[index][1] === true) {
                            newSVG += traces[index].getPathTag();  
                        }
                    }

                    newSVG += svgTail;
                    // you can send newSVG to the cloud here
                    // var svgPreview = 'data:image/svg+xml;base64,';
                    // svgPreview += window.btoa(newSVG);
                    // const preview = document.getElementById('preview');
                    // preview.src = svgPreview;     
                    // const blob = new Blob([newSVG], { type: 'image/svg+xml' });
                    // collectData(blob, "image-to-svg/downloads");
                    // const shareLink = uploadFile(blob, "svgConverter")
                    // props.setShareLink(shareLink);
                    // const url = URL.createObjectURL(blob);
                    // props.setDownloadSVGLink(url)
                    // props.setIsLoading(false);



                    parse(newSVG).then((json) => {
                        var newSvg2 = json;
                        newSvg2.attributes.width = "100%";
    
                        // split up the paths
    

                        for (let index = 0; index < json.children.length; index++) {
                            var newChildren = [];
                            // if (props.svg.children[index].attributes['fill'] === "white") {
                            const newString = json.children[index].attributes['d'].replace(/M/g, "|M")
    
                            const newArray = newString.split("|");
    
    
                            for (var i = 0; i < newArray.length; i++) {
                                var item = (' ' + newArray[i]).slice(1);
                                if (item !== "") {
                                    //console.log(item, i);
                                    const child = Object.assign({}, json.children[index]);
                                    // console.log("item", item);
                                    const attributes = Object.assign({}, child.attributes);
                                    attributes.d = item;
                                    child.attributes = attributes;
                                    // console.log("attributes after", child.attributes.d);
                                    // console.log("child after", child);
    
                                    newChildren.push(child);
                                }
                                
                            }
                            newSvg2.children[index].children = newChildren;
                            newSvg2.children[index].attributes['d'] = "";
                        }
                        // console.log("newChildren: ", newChildren);

    
    
                        // console.log("submit function; ", newSvg2);
                        // props.setRawSvg(stringify(newSvg2));

                        // setAppState({
                        //     ...appState,
                        //     svgString: stringify(newSvg2),
                        // });
                        setSvgString(stringify(newSvg2));
                        // props.setStep(2);
                    });
                });


                // props.setColorLayers(colorLayers);
                // props.setStep(2);
                props.setIsLoading(false);
            })
            .catch(err => {
                // Handle an exception.
                console.log(err)
            });
    }

    return (
        <>
            <Button disabled={(props.colors.length < 1) === true} onClick={(e) => { onClick(e) }} type="primary" htmlType="submit" style={{  width: '100%', marginBottom: '0px' }}>
                Next
            </Button>

        </>
    );
};

export default Submit;